import type { Ssm5FreezeFrameParameter } from '@packages/domain/ssm5';

/**
 * Read the PID name fragment without surrounding blanks.
 *
 * @param query - the current search query
 * @returns the trimmed text, or undefined when it is empty
 */
export function freezeFrameSearchText(query: string): string | undefined {
    const text = query.trim();

    return text === '' ? undefined : text;
}

/**
 * Find PIDs whose names contain the query, ignoring case and surrounding blanks.
 *
 * @param parameters - the reported PIDs
 * @param query - the name fragment to find
 * @returns matching PIDs in their reported order
 */
export function searchFreezeFrameParameters(
    parameters: readonly Ssm5FreezeFrameParameter[],
    query: string
): Ssm5FreezeFrameParameter[] {
    const searched = query.trim().toLowerCase();

    return parameters.filter((parameter) => parameter.name.toLowerCase().includes(searched));
}
